if (!customElements.get('currency-selector')) {
  customElements.define(
    'currency-selector',
    class CurrencySelector extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.cs-trigger');
        this.modal = this.querySelector('.cs-modal');
        this.dialog = this.querySelector('.cs-dialog');
        this.overlay = this.querySelector('.cs-overlay');
        this.closeEls = this.querySelectorAll('[data-cs-close]');
      }

      connectedCallback() {
        // Duration from data attribute (default: 350ms)
        const duration = parseInt(this.dataset.duration, 10) || 350;
        this.dialog.style.setProperty('--cs-duration', `${duration}ms`);

        this.trigger?.addEventListener('click', () => this.open());
        this.closeEls.forEach((el) => el.addEventListener('click', () => this.close()));

        // ESC key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.modal.classList.contains('is-active')) this.close();
        });
      }

      open() {
        this.originalParent = this.originalParent || this.modal.parentElement;
        document.body.appendChild(this.modal);

        this.modal.hidden = false;
        this.modal.classList.add('is-active');
        document.body.classList.add('cs-lock');

        // trigger animation next frame
        requestAnimationFrame(() => {
          this.dialog.classList.add('enter');
        });
      }

      close() {
        this.dialog.classList.remove('enter');
        this.dialog.classList.add('leave');
        document.body.classList.remove('cs-lock');

        // Use the duration from the CSS var for sync
        const duration =
          parseInt(getComputedStyle(this.dialog).getPropertyValue('--cs-duration')) || 350;

        setTimeout(() => {
          this.modal.classList.remove('is-active');
          this.modal.hidden = true;
          this.dialog.classList.remove('leave');

          this.originalParent.appendChild(this.modal);
        }, duration);
      }
    },
  );
}
